import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

const MESSAGES = [
  "Rendering attachment pages…",
  "Reading letterheads and cheque scans…",
  "Understanding the email context…",
  "Extracting the 16 vendor fields…",
  "Separating multiple vendors…",
  "Validating PAN and IFSC formats…",
  "Preparing your editable grid…",
];

export const ProcessingPanel = ({ fileCount = 0, hasEmail = false }) => {
  const [idx, setIdx] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const a = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), 2600);
    const b = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => {
      clearInterval(a);
      clearInterval(b);
    };
  }, []);

  return (
    <section className="vde-card p-4 sm:p-5" data-testid="processing-panel" aria-live="polite">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <Loader2 className="h-4 w-4 animate-spin text-primary" aria-hidden="true" />
          <div>
            <p className="text-sm font-semibold text-foreground">{MESSAGES[idx]}</p>
            <p className="text-xs text-muted-foreground">
              {fileCount > 0 ? `${fileCount} file${fileCount > 1 ? "s" : ""}` : "No files"}
              {hasEmail ? " + email body" : ""} · typically 10-40 seconds
            </p>
          </div>
        </div>
        <span className="vde-code text-xs text-muted-foreground">{seconds}s</span>
      </div>

      <div className="vde-bar mt-4 h-1.5 w-full rounded-full" />

      <div className="mt-4 space-y-2">
        <div className="vde-shimmer h-8 w-full rounded-md" />
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex gap-2">
            <div className="vde-shimmer h-10 w-[22%] rounded-md" />
            <div className="vde-shimmer h-10 w-[18%] rounded-md" />
            <div className="vde-shimmer h-10 w-[24%] rounded-md" />
            <div className="vde-shimmer h-10 w-[16%] rounded-md" />
            <div className="vde-shimmer hidden h-10 w-[20%] rounded-md sm:block" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProcessingPanel;
